// extracted by mini-css-extract-plugin
export default {"metrics":"metrics__xSzs0uNf","multiVariant":"multi-variant__fYrWmGfR"};